import { mutatorAction } from 'satcheljs';
import { AppendOnSendViewState } from 'owa-addins-core';

export default mutatorAction('removeAppendOnSend', (viewState: AppendOnSendViewState) => {
    viewState.appendOnSend = [];
});
